import { Select, Input, DatePicker, InputNumber } from "antd";
import "./newClientEscalation.css";
import TextArea from "antd/lib/input/TextArea";
import { useContext, useState } from "react";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { newClientEscalation } from "../../../utils/Constants";

const onSearch = (value) => {};

const NewClientEscalation = () => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;
    if (enteredEmail) {
      // Regular expression for basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      setIsValidEmail(emailRegex.test(enteredEmail));
      setGlobalState((prevGlobalState) => {
        const newGlobalState = {
          ...prevGlobalState,
          eClientSpocEmailVal: "",
          eClientSpocEmail: emailRegex.test(enteredEmail),
        };
        return newGlobalState;
      });
    } else {
      setIsValidEmail("false");
    }
  };

  return (
    <div id="antdformstyle">
      {newClientEscalation.map((section) => (
        <div key={section.key}>
          <div className="formtitle">{section.title}</div>
          <div className="details-container px-3">
            {section.key === "rcaDetails"
              ? section.fields
                  .reduce((rows, field, index) => {
                    if (index % 2 === 0) {
                      rows.push(section.fields.slice(index, index + 2));
                    }
                    return rows;
                  }, [])
                  .map((fieldPair, pairIndex) => (
                    <div className="details-wrap" key={pairIndex}>
                      {fieldPair.map((field, i) => {
                        // Logic for RCA only
                        const shouldShow =
                          field.key === "rcaLevelOne" ||
                          (field.key === "rcaLevelTwo" &&
                            globalState?.rcaLevelOneVal) ||
                          (field.key === "rcaLevelThree" &&
                            globalState?.rcaLevelTwoVal) ||
                          (field.key === "rcaLevelFour" &&
                            globalState?.rcaLevelThreeVal);

                        if (!shouldShow) return null;

                        let options = field.options;
                        if (field.optionsByParent) {
                          const parentKey =
                            field.key === "rcaLevelTwo"
                              ? globalState?.rcaLevelOne
                              : field.key === "rcaLevelThree"
                              ? globalState?.rcaLevelTwo
                              : field.key === "rcaLevelFour"
                              ? globalState?.rcaLevelThree
                              : null;

                          options = parentKey
                            ? field.optionsByParent[
                                parentKey
                                  .toLowerCase()
                                  .replace(/[^a-z0-9]/g, "")
                              ] || []
                            : [];
                          // console.log(
                          //   field,
                          //   field.optionsByParent,
                          //   field.key,
                          //   ",parentKey:",
                          //   parentKey.toLowerCase().replace(/[^a-z0-9]/g, ""),
                          //   options
                          // );
                        }

                        return (
                          <div key={field.key} className="details-inner">
                            <div className="form-label-antd">{field.label}</div>
                            <Select
                              showSearch
                              allowClear
                              placeholder={field.placeholder}
                              options={options}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(val, option) => {
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: option?.label,
                                  [field.key]: val || field.errorMessage,

                                  ...(field.key === "rcaLevelOne" && {
                                    rcaLevelTwo: null,
                                    rcaLevelTwoVal: null,
                                    rcaLevelThree: null,
                                    rcaLevelThreeVal: null,
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                  ...(field.key === "rcaLevelTwo" && {
                                    rcaLevelThree: null,
                                    rcaLevelThreeVal: null,
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                  ...(field.key === "rcaLevelThree" && {
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                }));
                              }}
                            />

                            {globalState?.[`${field.key}`] ===
                              field.errorMessage && (
                              <div className="error">{field.errorMessage}</div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ))
              : section.fields
                  .reduce((rows, field, index) => {
                    // Group into pairs
                    if (index % 2 === 0) {
                      rows.push(section.fields.slice(index, index + 2));
                    }
                    return rows;
                  }, [])
                  .map((fieldPair, pairIndex) => (
                    <div className="details-wrap" key={pairIndex}>
                      {fieldPair.map((field) => (
                        <div key={field.key} className="details-inner">
                          <div className="form-label-antd">{field.label}</div>

                          {field.type === "input" && (
                            <Input
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(e) => {
                                if (field.validate === "email") {
                                  handleEmailChange(e);
                                }
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: e.target.value,
                                  [field.key]:
                                    e.target.value || field.errorMessage,
                                }));
                              }}
                            />
                          )}

                          {field.type === "number" && (
                            <InputNumber
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(value) => {
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: value,
                                  [field.key]: value || field.errorMessage,
                                }));
                              }}
                            />
                          )}

                          {field.type === "date" && (
                            <DatePicker
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(date) => {
                                const dayName = date ? date.format("ddd") : "";

                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: date,
                                  [field.key]: date || field.errorMessage,
                                  ...(field.key === "eTransactionDate"
                                    ? { eDayoftheweekVal: dayName || null }
                                    : {}),
                                }));
                              }}
                            />
                          )}

                          {field.type === "readonly" && (
                            <div className="readonly-field">
                              <span>{globalState?.[`${field.key}Val`]}</span>
                            </div>
                          )}

                          {field.type === "textarea" && (
                            <TextArea
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(e) =>
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: e.target.value,
                                  [field.key]:
                                    e.target.value || field.errorMessage,
                                }))
                              }
                            />
                          )}

                          {field.type === "select" && (
                            <Select
                              showSearch
                              allowClear
                              placeholder={field.placeholder}
                              optionFilterProp="children"
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(val, option) => {
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: option?.label,
                                  [field.key]: val || field.errorMessage,
                                }));
                              }}
                              onSearch={onSearch}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={field.options}
                            />
                          )}

                          {globalState?.[`${field.key}`] ===
                            field.errorMessage && (
                            <div className="error">{field.errorMessage}</div>
                          )}

                          {field.validate === "email" && !isValidEmail && (
                            <div className="error">
                              Please enter a valid email address.
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
          </div>
        </div>
      ))}
    </div>
  );
};
export default NewClientEscalation;
